/**
 * The Team menu of the top bar, carrying the AI team's state: the dot says
 * needs-you / working / idle, the number how many things wait on the owner
 * (questions, reviews, email drafts, employees that need help). The menu
 * lists the Team sections with the same counts as the team sub-nav.
 * Admin-only — Layout renders it only once `isAdmin` is `true`.
 */
import { useTeamStatus } from "../../hooks/useTeamStatus";
import { teamSections } from "../../lib/aiTeam";
import { NavMenu } from "./NavMenu";

// Literal class names — Tailwind keeps a component class only if its exact
// string appears in source.
const DOT_CLASS = {
  "needs-you": "nav-dot is-needs-you",
  working: "nav-dot is-working",
  idle: "nav-dot is-idle",
} as const;

export function TeamNavItem() {
  const status = useTeamStatus();
  return (
    <NavMenu
      label="Team"
      title={status.breakdown}
      items={teamSections(status.counts)}
      trigger={
        <>
          Team
          <span className={DOT_CLASS[status.presence]} aria-hidden />
          {status.needsYou > 0 ? (
            <>
              <span className="nav-count" aria-hidden>
                {status.needsYou}
              </span>
              <span className="sr-only">, {status.needsYou} need you</span>
            </>
          ) : null}
        </>
      }
    />
  );
}
